module.exports = __webpack_public_path__ + "9f929f9689e6ff33dee6fdfe531961d0.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-22.cur
// module id = 447
// module chunks = 0